<div class="app-page" >
  @if (this.isBusy) {
    <mat-progress-spinner
      class="loading-indicator"
      color="primary"
      mode="indeterminate"
      >
    </mat-progress-spinner>
  }
  &nbsp;
  <h2>
    <mat-icon style="font-size: 48px; height: 48px; width: 48px;"> sports_hockey </mat-icon>
    GAMES
  </h2>
  @if (this._userService.roleMatch(['Org_Admin'])) {
    <a mat-raised-button (click)="sendReminder()">
      <mat-icon >send</mat-icon>
    SEND REMINDER TO PLAYERS</a>
  }
  <mat-divider></mat-divider>
  @if(!this.isBusy && this.games?.length > 0){
    <h3 >Overview</h3>
    <app-game-charts [GameList]="this.games" ></app-game-charts>
    <mat-divider></mat-divider>
    <h3>Game details</h3>
    <div style="display: flex; flex-wrap: wrap;">
      @if (this.games?.length==0) {
        <div style="display: flex; justify-content: center; margin-top: 30px;" >
          <div style="font-family: Roboto;">No games played yet</div>
        </div>
      }


      @for (game of this.games; track game) {
        <app-load-game-card [GameEvent]="game" [TeamId]="this.TeamId" [ShowStatistics]="this.isStatisticsUser" >
        </app-load-game-card>
      }
    </div>
  }
  @if(this.games?.length == 0){
    <h2>
      <mat-icon> warning </mat-icon>No games available
    </h2>




    <div style="font-family: Roboto; font-size: mdedium ; color: gray; margin-top: 30px;">Reasons could be that no games have been scheduled yet or that the new season is not defined in Dalecarlia Scouting for this team.</div>
  }




</div>

